<template>
  <svg
    ref="spinnerRef"
    width="70"
    height="70"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :class="[
        'origin-center fill-blue-500 animate-spin',
        { 'animate-pulse': isVisible }
      ]"
      d="M12,23a9.63,9.63,0,0,1-8-9.5,9.51,9.51,0,0,1,6.79-9.1A1.66,1.66,0,0,0,12,2.81h0a1.67,1.67,0,0,0-1.94-1.64A11,11,0,0,0,12,23Z"
    />
  </svg>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const props = defineProps({
  // Set a positive number (ms) to enable auto-reload after spinner is visible that long.
  // Default 0 disables any reload behavior.
  autoReloadAfterMs: {
    type: Number,
    default: 0
  }
})

const spinnerRef = ref(null)
const isVisible = ref(true)
let timeoutId = null

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach(entry => {
      isVisible.value = entry.isIntersecting
      if (isVisible.value && props.autoReloadAfterMs > 0) {
        if (timeoutId) {
          clearTimeout(timeoutId)
          timeoutId = null
        }
        timeoutId = setTimeout(() => {
          window.location.reload()
        }, props.autoReloadAfterMs)
      } else {
        if (timeoutId) {
          clearTimeout(timeoutId)
          timeoutId = null
        }
      }
    })
  },
  { threshold: 0 }
)

onMounted(() => {
  if (spinnerRef.value) {
    observer.observe(spinnerRef.value)
  }
})

onBeforeUnmount(() => {
  observer.disconnect()
  if (timeoutId) {
    clearTimeout(timeoutId)
    timeoutId = null
  }
})
</script>